module.exports = __webpack_public_path__ + "img/facebook.606755dc.svg";